// SPDX-License-Identifier: AGPL-3.0-or-later

import type {Message} from '@app/features/messaging/models/Message';
import {openReportUserModal} from '@app/features/moderation/utils/ReportActionUtils';
import {ReportUserIcon} from '@app/features/ui/action_menu/ContextMenuIcons';
import {MenuItem} from '@app/features/ui/action_menu/MenuItem';
import type {User} from '@app/features/user/models/User';
import {useLingui} from '@lingui/react/macro';
import {observer} from 'mobx-react-lite';
import type React from 'react';
import {useCallback} from 'react';

interface ReportUserMenuItemProps {
	user: User;
	onClose: () => void;
	guildId?: string;
	message?: Message;
}
export const ReportUserMenuItem: React.FC<ReportUserMenuItemProps> = observer(({user, onClose, guildId, message}) => {
	const {t, i18n} = useLingui();
	const handleReportUser = useCallback(() => {
		onClose();
		openReportUserModal({
			i18n,
			user,
			guildId,
			message,
		});
	}, [guildId, i18n, message, onClose, user]);
	return (
		<MenuItem icon={<ReportUserIcon size={16} />} onClick={handleReportUser} danger>
			{t`Report User`}
		</MenuItem>
	);
});
